module.exports = __webpack_public_path__ + "img/work-card1.0b57cc17.png";